import AnimGallery from '@src/framework/frame-pc/components/anim-gallery';
import React, { Component } from 'react';
import { ANIMATION_LIST, ANIM_RECENT_ID } from '../constants';
import { AnimationHistory } from '../animationHistory';
import { AnimType } from '@tencent/slide-sdk-model';
export interface IAnimHistoryGalleryProps {
    onSelect: (animType: string, presetClass: string, isFromRecent?: boolean) => void;
}
export class AnimHistoryGallery extends Component<IAnimHistoryGalleryProps> {
    private animHistory: AnimationHistory;

    public constructor(props) {
        super(props);
        this.animHistory = AnimationHistory.getInstance();
    }

    public handleClick = (animType: string, categoryId?: string) => {
        const animIndex = ANIMATION_LIST.findIndex(item => item.id === animType);
        this.animHistory.setAnimationHistory(animType as AnimType);
        if (animIndex > -1) {
            const animation = ANIMATION_LIST[animIndex];
            const { prefixClass } = animation;
            this.props.onSelect(animType, prefixClass, categoryId === ANIM_RECENT_ID);
        }
    };

    public render() {
        const galleryList   = this.animHistory.getAllAnimWithHistory();

        return (
            <AnimGallery
                selectedId={''}
                animCategoryList={galleryList}
                onClick={this.handleClick}
            />
        );
    }
}

export default AnimHistoryGallery;
